import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2a3ed79c"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = {
  key: 0,
  points: "50,8 94,90 6,90"
};
const _hoisted_3 = {
  key: 1,
  x: "10",
  y: "10",
  width: "80",
  height: "80",
  rx: "2"
};
const _hoisted_4 = {
  key: 2,
  points: "50,4 61,36 95,36 67,56 78,90 50,70 22,90 33,56 5,36 39,36"
};
const _hoisted_5 = {
  key: 3,
  cx: "50",
  cy: "50",
  rx: "37",
  ry: "44"
};
const _hoisted_6 = {
  key: 4,
  points: "50,5 94,38 77,91 23,91 6,38"
};
const _hoisted_7 = {
  key: 5,
  d: "M39 7h22v32h32v22H61v32H39V61H7V39h32z"
};
const _hoisted_8 = {
  key: 6,
  d: "M12 88V8c44 0 80 36 80 80z"
};
const _hoisted_9 = {
  key: 7,
  points: "25,8 75,8 91,91 9,91"
};
const _hoisted_10 = {
  key: 8,
  points: "50,5 91,50 50,95 9,50"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    class: "digit-symbol-shape",
    viewBox: "0 0 100 100",
    style: _normalizeStyle({
      width: `${$props.size}px`,
      height: `${$props.size}px`
    }),
    role: "img",
    "aria-label": $options.shapeLabel
  }, [$props.shapeId === 'TRIANGLE' ? (_openBlock(), _createElementBlock("polygon", _hoisted_2)) : $props.shapeId === 'SQUARE' ? (_openBlock(), _createElementBlock("rect", _hoisted_3)) : $props.shapeId === 'STAR' ? (_openBlock(), _createElementBlock("polygon", _hoisted_4)) : $props.shapeId === 'CIRCLE' ? (_openBlock(), _createElementBlock("ellipse", _hoisted_5)) : $props.shapeId === 'PENTAGON' ? (_openBlock(), _createElementBlock("polygon", _hoisted_6)) : $props.shapeId === 'PLUS' ? (_openBlock(), _createElementBlock("path", _hoisted_7)) : $props.shapeId === 'QUARTER_CIRCLE' ? (_openBlock(), _createElementBlock("path", _hoisted_8)) : $props.shapeId === 'TRAPEZOID' ? (_openBlock(), _createElementBlock("polygon", _hoisted_9)) : $props.shapeId === 'DIAMOND' ? (_openBlock(), _createElementBlock("polygon", _hoisted_10)) : _createCommentVNode("", true)], 12, _hoisted_1);
}